import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import ReportApprovals from "./ReportApprovals";
import ReportHistoryLog from "./ReportHistoryLog";
import ReportList from "./ReportList";

const TABS = [
    { id: "approvals", label: "Approvals" },
    { id: "history", label: "History" },
    { id: "report_list", label: "Report List" },
];

const ReportApprovalHub = () => {
    const [searchParams] = useSearchParams();
    const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
        ? searchParams.get("tab")
        : "approvals";
    const [activeSection, setActiveSection] = useState(initialTab);

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div className="section-buttons-container" style={{ border: "0px" }}>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        className={`section-button ${activeSection === tab.id ? "active" : ""}`}
                        onClick={() => setActiveSection(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="section-content-container">
                <div className={`section-container ${activeSection === "approvals" ? "active-section" : "hidden-section"}`}>
                    <ReportApprovals />
                </div>
                <div className={`section-container ${activeSection === "history" ? "active-section" : "hidden-section"}`}>
                    <ReportHistoryLog />
                </div>
                <div className={`section-container ${activeSection === "report_list" ? "active-section" : "hidden-section"}`}>
                    <ReportList />
                </div>
            </div>
        </div>
    );
};

export default ReportApprovalHub;
